import { FormControl, Grid, InputAdornment, InputLabel, OutlinedInput } from '@mui/material'
import React from 'react'
import { parseFloatOr } from '../../../../../common/utils/parseNumericInput'

function MaxRiskField({ analyze, updateSetting }: { analyze: any; updateSetting: any }) {
  return (
    <Grid item xs={12} sm={6}>
      <FormControl fullWidth variant="outlined">
        <InputLabel htmlFor="outlined-adornment-maxRisk">Max risk</InputLabel>
        <OutlinedInput
          id="outlined-adornment-maxRisk"
          name="analyzeTrades.maxRisk"
          type="number"
          value={analyze.maxRisk ? analyze.maxRisk * 100 : ''}
          placeholder="∞"
          onChange={(e) =>
            // 0 is the "unlimited" sentinel, and what an empty box means.
            updateSetting('analyzeTrades.maxRisk', parseFloatOr(e.target.value, 0) / 100)
          }
          inputProps={{ min: 0 }}
          startAdornment={<InputAdornment position="start">%</InputAdornment>}
          label="Max risk"
        />
      </FormControl>
    </Grid>
  )
}

export default MaxRiskField
